import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';

const MuiDialog = (props) => {
  const {
    children,
    disableBackdropClick,
    disableEscapeKeyDown,
    onClose,
    ...restProps
  } = props;

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return false;
    }

    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return false;
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Dialog
      fullWidth={true}
      scroll={'paper'}
      onClose={handleClose}
      transitionDuration={{ enter: 300 }}
      {...restProps}
    >
      {children}
    </Dialog>
  );
};

MuiDialog.propTypes = {
  // Dialog children, usually the included sub-components.
  children: PropTypes.node,
  // If true, clicking the backdrop will not fire the onClose callback.
  disableBackdropClick: PropTypes.bool,
  // If true, hitting escape will not fire the onClose callback.
  disableEscapeKeyDown: PropTypes.bool,
  // Callback fired when the component requests to be closed.
  onClose: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                              
// *************************************

// Dialog
export const StyledDialog = styled(MuiDialog)`
  .MuiDialog-paperWidthXs {
    max-width: 350px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthSm {
    max-width: 500px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthMd {
    max-width: 800px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthLg {
    max-width: 1000px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthXl {
    max-width: 1300px;
    border-radius: 6px;
  }
`;

// Dialog Title
export const StyledDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    min-height: 60px;
    padding: 16px; 
    display: flex;
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }

  .MuiTypography-root {
    font-family: 'Bryant Pro Medium';
    font-size:  ${(props) => props.theme.typography.heading5};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
    display: flex;
    flex: 1;
    align-items: center;
    color: ${(props) => props.theme.colors.greyDark};
    background-color: ${(props) => props.theme.colors.white};
    backface-visibility: hidden;
  }
`;

// Dialog Content
export const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 16px;
    color: ${(props) => props.theme.colors.greyDark};
    background-color: ${(props) => props.theme.colors.white};
    scrollbar-width: thin !important;
    backface-visibility: hidden;
  }
`;

// Dialog Actions
export const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px;
    border-top: 1px solid ${(props) => props.theme.colors.greyLight};
    background-color: ${(props) => props.theme.colors.white};
  }
`;

// Dialog BoxIcon (optional) 
export const StyledDialogBoxIcon = styled.div`
  display: flex;
  align-items: center;
  padding-right: 16px;

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

// Dialog BoxClose
export const StyledDialogBoxClose = styled(IconButton)`
  &.MuiIconButton-root {
    position: absolute;
    right: 8px;
    padding: 8px;
    color: ${(props) => props.theme.colors.greyDark};
    &:hover {
      background-color: ${(props) => props.theme.colors.greyHover};;
    }
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;
